import React from "react";

const ToggleSwitch = ({ selectValue, versionValue, toggle, label, required }) => {
    return (
        <div className="toggle-switch">
            <label className="block font-medium mb-1">
                {label} {required && <span className="text-red-500">*</span>}
            </label>
            {versionValue ? <p>Old Data</p> : null}
            {versionValue && (
                <>
                    <input type="checkbox" id="toggle-switch" disabled={true} checked={versionValue} />
                </>
            )}
            <br />
            {versionValue ? <p>New Data</p> : null}
            <input onChange={() => toggle()} type="checkbox" id="toggle-switch" checked={selectValue} />
        </div>
    );
};

export default ToggleSwitch;
